import { CardFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/CardFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/LoadingCardFragment/LoadingCardFragment";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import { ItemNoAndType } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { useItemInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemInfo";
import { ItemTaskCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemTaskCard/ItemTaskCard";

export type ItemCardFragmentConfigProps = {
  field: string;
};

type ItemCardFragmentProps = {
  configProps: ItemCardFragmentConfigProps;
  commonProps: CardFragmentCommonProps;
};

function ItemCardFragment({ configProps, commonProps }: ItemCardFragmentProps) {
  const { field } = configProps;
  const { task } = commonProps;
  const itemNoAndType = getTypedValue<ItemNoAndType>(getByPath(task, field));

  const { data: item } = useItemInfo((itemNoAndType as ItemNoAndType)?.no);

  if (isLoading(item)) {
    return <LoadingCardFragment />;
  } else if (!item) {
    return null;
  }

  return <ItemTaskCard item={item} />;
}

export default ItemCardFragment;
